import { defineMessages } from 'react-intl';

export default defineMessages({
  trackingInfoTitle: {
    id: 'components.myaccount.trackingInfo.trackingInfoTitle',
    defaultMessage: 'Tracking',
  },
  trackingNumberLabel: {
    id: 'components.myaccount.trackingInfo.trackingNumberLabel',
    defaultMessage: 'Tracking number',
  },
  trackingUrlLabel: {
    id: 'components.myaccount.trackingInfo.trackingUrlLabel',
    defaultMessage: 'Tracking link',
  },
});
